





























import { Component, Prop, Vue } from 'vue-property-decorator';

import ModalVue from './Modal.vue';
import Message from '../../engine/Message';



@Component({
    components: {
        ModalVue
    },
})
export default class MessageVue extends Vue {

    @Prop()
    private message!: Message;
 
    close(){
        this.$emit('close');
    }


}

